export const contactColumns = ({
  selectedIds,
  handleSelectAll,
  handleSelect,
  totalRows,
}) => [
    {
      id: "select",
      label: (
        <input
          type="checkbox"
          checked={
            totalRows > 0 &&
            selectedIds.length === totalRows
          }
          onChange={handleSelectAll}
        />
      ),

      render: (c) => (
        <input
          type="checkbox"
          checked={selectedIds.includes(c.id)}
          onChange={() => handleSelect(c.id)}
          onClick={(e) => e.stopPropagation()}
        />
      ),
    },

    {
      id: "name",
      label: "Contact",

      render: (c) => {
        const initials = `${c.first_name?.[0] || ""}${c.second_name?.[0] || ""}`;

        const avatarColors = [
          { bg: "#EDE9FE", color: "#7C3AED" },
          { bg: "#DBEAFE", color: "#2563EB" },
          { bg: "#DCFCE7", color: "#16A34A" },
          { bg: "#FDE68A", color: "#D97706" },
          { bg: "#FCE7F3", color: "#DB2777" },
        ];

        const color = avatarColors[c.id % avatarColors.length];

        return (
          <div className="contact-cell">
            <div
              className="contact-avatar"
              style={{
                background: color.bg,
                color: color.color,
              }}
            >
              {initials.toUpperCase()}
            </div>

            <div className="contact-info">
              <div className="contact-name">
                {c.first_name} {c.second_name}
              </div>

              <div className="contact-email">
                {c.email}
              </div>
            </div>
          </div>
        );
      },

      exportValue: (c) =>
        `${c.first_name || ""} ${c.second_name || ""}`.trim(),
    },

    {
      id: "organization",
      label: "Organization",

render: (c) => {
  return (
    c.organizations
      ?.map((org) => org.name)
      .join(", ") || "-"
  );
},


      exportValue: (c) =>
        c.organizations
          ?.map((org) => org.name)
          .join(", ") || "",
    },

    {
      id: "phone",
      label: "Phone",

      render: (c) => c.phone,
    },

    {
      id: "designation",
      label: "Designation",

      render: (c) => c.designation || "-",
    },

    {
      id: "open_leads",
      label: "Active Leads",

      render: (c) => c.open_leads || 0,

      exportValue: (c) => c.open_leads || 0,
    },

    {
      id: "open_deals",
      label: "Active Deals",

      render: (c) => c.open_deals || 0,

      exportValue: (c) => c.open_deals || 0,
    },

    {
      id: "status",
      label: "Status",

      render: (c) => {
        const status = c.organizations?.[0]?.status;

        return (
          <span className={`status-badge status-${status?.toLowerCase()}`}>
            {status || "-"}
          </span>
        );
      },

      exportValue: (c) => c.organizations?.[0]?.status || "",
    }
  ];
